import { useMutation, useQuery } from "react-query";
import { AxiosError } from "axios";
import { config } from "../config";
import { DEFAULT_QUERY_OPTIONS } from "../constants";
import { ApiError, QueryOptions, TermsAcceptance } from "../types";
import { client } from "./axios";

export const useFetchTermsQuery = (
  orgId: number,
  userId: number,
  queryOptions?: QueryOptions<ArrayBuffer>,
) => {
  const fetchTerms = async (): Promise<ArrayBuffer> => {
    const path = config.api.userService.getTerms
      .replace("{orgId}", orgId.toString())
      .replace("{userId}", userId.toString());
    const response = await client.get<ArrayBuffer>(path, {
      headers: {
        Accept: "application/pdf",
      },
      responseType: "arraybuffer",
    });
    return response.data;
  };

  return useQuery(["fetchTerms", orgId, userId], fetchTerms, {
    ...DEFAULT_QUERY_OPTIONS,
    ...queryOptions,
  });
};

export const useAcceptTermsMutation = () => {
  const mutation = useMutation<
    TermsAcceptance,
    AxiosError<ApiError>,
    { orgId: number; userId: number },
    unknown
  >(async ({ orgId, userId }: { orgId: number; userId: number }) => {
    const path = config.api.userService.acceptTerms
      .replace("{orgId}", orgId.toString())
      .replace("{userId}", userId.toString());

    const response = await client.put(path);
    return response.data.response;
  });

  return mutation;
};
